import LoggerService from "./logger.service";
import environment from "../environments/environment.json";
import { VARIABLE_SAFE_URL_SUPPLIER_LINK, VARIABLE_SAFE_URL_TOKEN } from "../constants/redirect.constants";

// Set once a redirect has started; any later call on the same page is ignored
// so the client/supplier URL is hit only once.
let redirectInProgress = false;

// Page restored from back/forward cache (user pressed Back) — allow redirects again.
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    redirectInProgress = false;
  }
});

export function windowLocation(url,token = "") {
  if (redirectInProgress) {
    return true;
  }
  LoggerService.log(
    token,
    "",
    "windowLocation:: Going to redirect : "+url
  );
    // Validate the URL
    if (!url || typeof url !== 'string' || !url.trim()) {
      if(token !== "") {
        LoggerService.log(
          token,
          "",
          "windowLocation:: Invalid url error : "+url
        );
      }
      console.error('Invalid URL provided for redirect:', url);
      return false;
    }
  
    try {
      // Normalize the URL (ensure it has a protocol, e.g., https://)
      let normalizedUrl = url;
      if (!/^https?:\/\//i.test(url)) {
        normalizedUrl = window.location.protocol + '//' + url.replace(/^\/+/, '');
      }
  
      redirectInProgress = true;
      window.location.assign(normalizedUrl);
      return true;
    } catch (error) {
      console.error('Redirect failed:', error);
      // Fallback: Use a meta refresh tag for extreme cases
      const meta = document.createElement('meta');
      meta.httpEquiv = 'refresh';
      meta.content = `0;url=${url}`;
      document.head.appendChild(meta);
      return false;
    }
  }

export function windowLocationRelayed(url,token = "",destination="supplier") {
    if (redirectInProgress) {
      return true;
    }
    LoggerService.log(
      token,
      "",
      "windowLocationRelayed:: Going to redirect : "+url
    );
    
    
    let params = `${url}`;
    let safeRedirectUrl = `${environment.SAFE_REDIRECT_APP}?voq_token=${token}&redirect_to=${destination}&link=${encodeURIComponent(params)}`;
      // Validate the URL
      

      try {
        // Normalize the URL (ensure it has a protocol, e.g., https://)
        let normalizedUrl = safeRedirectUrl;
        if (!/^https?:\/\//i.test(url)) {
          normalizedUrl = window.location.protocol + '//' + url.replace(/^\/+/, '');
        }
    
        redirectInProgress = true;
        window.location.assign(normalizedUrl);
        return true;
      } catch (error) {
        console.error('Redirect failed:', error);
        if(token !== "") {
          LoggerService.log(
            token,
            "",
            `windowLocationRelayed:: Redirect failed, In Catch Using refresh: ${url}`
          );
        }
        // Fallback: Use a meta refresh tag for extreme cases
        const meta = document.createElement('meta');
        meta.httpEquiv = 'refresh';
        meta.content = `0;url=${url}`;
        document.head.appendChild(meta);
        return false;
      }
    }